import { useContext } from "react";
import { AccordionContext, Form, useAccordionButton } from "react-bootstrap";
import { useAppSelector } from "../../redux/Store";
import { ITRFilingSelector } from "../../redux/slice/ITRFilingSlice";

const SwitchBtnContextAwareToggle = ({ eventKey, callback, onChange, name, isDisabled }: any) => {
	const { activeEventKey } = useContext(AccordionContext);

	const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

	const isCurrentEventKey = activeEventKey === eventKey;

	const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

	/* const isFieldDisabled = useMemo(() => {
    if (isFilingReadOnly) {
      return true;
    }
    return false;
  }, [isFilingReadOnly]); */

	return (
		<Form.Group className="form-group" controlId={name}>
			<Form.Switch
				className="label-inside"
				reverse={true}
				label={isCurrentEventKey ? "Yes" : "No"}
				checked={isCurrentEventKey}
				onClick={decoratedOnClick}
				readOnly={true}
				name={name}
				onChange={(e) => onChange(e.target.checked)}
				disabled={isFilingReadOnly || isDisabled}
			/>
		</Form.Group>
	);
};

export default SwitchBtnContextAwareToggle;
